<template>
	<div>
		<el-dialog title="修改产品" width="600px" class="icon-dialog" :visible.sync="show" @open="open"
			:before-close="closeForm" append-to-body>
			<el-form :size="size" ref="form" :model="form" :rules="rules"
				:label-width="$store.getters.device !== 'mobile' ? '16%' : '90px'">
				<el-row>
					<el-col :span="24">
						<el-form-item label="产品名称" prop="name">
							<el-input v-model="form.name" autoComplete="off" clearable placeholder="请输入视频标题"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="产品排序" prop="sort">
							<el-input v-model="form.sort"  clearable placeholder="请输入多少秒"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button :size="size" :loading="loading" type="primary" @click="submit">
					<span v-if="!loading">确 定</span>
					<span v-else>提 交 中...</span>
				</el-button>
				<el-button :size="size" @click="closeForm">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { getCpedit } from '../../api/userMG';
export default {
	name: 'Add',
	components: {
	},
	props: {
		show: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
			default: 'small'
		},
		info: {
			type: Object,
		}
	},
	data() {
		return {
			form: {
			},
			loading: false,
			rules: {
			}
		}
	},
	methods: {
		open() {
			this.form = this.info
			this.form.echo = 'set'
		},
		submit() {
			console.log(this.form);
			this.$refs['form'].validate(valid => {
				if (valid) {
					this.loading = true
					getCpedit(this.form).then(res => {
						console.log(res.code);
						if (res.code == 200) {
							this.$message({ message: '操作成功', type: 'success' })
							this.$emit('refesh_list')
							this.closeForm()
						} else {
							this.$message({ message: res.msg, type: 'error' })
							this.loading = false
						}
					}).catch(() => {
						this.loading = false
					})
				}
			})
		},
		closeForm() {
			this.$emit('update:show', false)
			this.loading = false
			if (this.$refs['form'] !== undefined) {
				this.$refs['form'].resetFields()
			}
		},
	}
}
</script>
<style></style>


// WEBPACK FOOTER //
// src/views/product/update.vue